<template>
  <list-view-cell :context-menu-items="contextMenuItems">
    <div v-if="note.status">
      <!-- Put icon here -->
    </div>
    <p class="mt-2">{{ note.text }}</p>
  </list-view-cell>
</template>

<script>
import ListViewCell from "../ListViewCell";
import { ContextMenuItem } from "../../../../helper-classes/ContextMenuItem";
import ContractNoteForm from "../../../../views/contracts/forms/ContractNoteForm";

export default {
  name: "ContractNoteCell",
  components: { ListViewCell },
  props: {
    note: Object
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("edit", () => {
          this.$store.commit("setCreateEditComponentParams", {
            createEditComponent: ContractNoteForm,
            createEditComponentData: this.procurement,
            createEditComponentIsShown: true
          });
        }),
        new ContextMenuItem("delete", () => {
          this.$store.commit("setConfirmationModalParams", {
            type: "delete",
            headerText: "Delete Confirmation",
            bodyComponent: undefined,
            bodyComponentData: this.procurement,
            isShown: true
          });
        })
      ]
    };
  }
};
</script>

<style scoped></style>
